import { components } from 'react-select';
import classNames from 'classnames';

import IconCheck from '../../../IconCheck/IconCheck';
import IconRadio from '../../../IconRadio/IconRadio';

import css from './Option.module.css';

const Option = props => {
  const {
    children,
    isMulti,
    isSelected,
    data: { icon },
  } = props;
  const Icon = isMulti ? IconCheck : IconRadio;

  return (
    <components.Option {...props}>
      <div
        className={classNames(css.checkbox, {
          [css.checked]: isSelected,
          [css.multiple]: isMulti,
        })}
      >
        {icon || <Icon className={css.icon} />}
      </div>
      {children}
    </components.Option>
  );
};

export default Option;
